import apiRequest from './apiRequest';
import { result } from 'lodash';

/**
 * Our drop-in for Backbone.sync used in both Entity and Collection
 * The parameters are defined by Backbone. We should never call this directly.
 */
const methodMap = {
  create: 'POST',
  read: 'GET',
  update: 'PUT',
  patch: 'PATCH',
  delete: 'DELETE',
};

/**
 * options.method overrides the defaultMethod arg
 */
type DefaultMethods = 'POST' | 'GET' | 'PUT' | 'PATCH' | 'DELETE' | undefined;
type Methods = 'create' | 'read' | 'update' | 'patch' | 'delete';

export default function sync(defaultMethod: DefaultMethods, model: any, options: any) {
  let url = options.url;
  if (!url) {
    url = result(model, 'url');
  }

  if (!url) {
    throw new Error('A "url" property or function must be specified');
  }

  const method: Methods = 'method' in options ? options.method : defaultMethod;
  let data = options.data;

  if (!data && model && (method === 'create' || method === 'update' || method === 'patch')) {
    data = options.attrs || model.toJSON(options);
  }

  return apiRequest(url, methodMap[method] || method, data).then(options.success, options.error);
}
